import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const ClassNotebookLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M64 1791V263L1216 56v1936L64 1791zM321 660v706l115 6V854l307 534 154 9V631l-145 8v257q0 128 1 257L467 655l-146 5zm1637 172q13 0 19 12t7 24v248q0 11-6 23t-20 13h-38V832h38zm0 384q13 0 19 12t7 24v248q0 11-6 23t-20 13h-38v-320h38zm26-469q0 13-3 17t-17 4h-108v909q0 7-2 16t-7 16-11 13-15 6h-541v-192h384v-64h-384v-128h384v-64h-384V320h541q20 0 27 17t8 34v77h108q14 0 17 3t3 18v278zm-231-21l39-50-39-50v-58l-49-29-29-50h-58l-50-36-50 36h-58l-28 50-50 29v58l-37 50 37 50v57l50 29 28 50h14v233l93-85 97 85V862h12l29-50 49-29v-57zm-186-152q19 0 37 7t31 20 21 30 8 38q0 20-8 37t-21 32-31 22-37 8q-20 0-37-8t-32-22-22-31-8-38q0-20 8-37t22-30 31-20 38-8z" />
    </svg>
  ),
  displayName: 'ClassNotebookLogoInverse32Icon',
});

export default ClassNotebookLogoInverse32Icon;
